import { FormsModule } from '@angular/forms';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetComponent } from './widget/widget.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { UtilitiesModule } from '../utilities/utilities.module';
import { WidgetListComponent } from './widget-list/widget-list.component';
import { WidgetContentSitemapComponent } from './widget-content/sitemap/sitemap.component';
import { WidgetContentSitemapChildItemsComponent } from './widget-content/sitemap-child-items/sitemap-child-items.component';
import { WidgetSitemapEditComponent } from './sitemap/edit/edit.component';
import { WidgetContentForumFeedComponent } from './widget-content/forum-feed/forum-feed.component';
import { NewsFeedModule } from '../news-feed/news-feed.module';
import { WidgetContentNewsFeedComponent } from './widget-content/news-feed/news-feed.component';
import { WidgetNewsFeedComponent } from './widget/news-feed/news-feed.component';
import { WidgetForumFeedComponent } from './widget/forum-feed/forum-feed.component';
import { WidgetSitemapComponent } from './widget/sitemap/sitemap.component';
import { WidgetAdvancedTextComponent } from './widget/advanced-text/advanced-text.component';
import { WidgetContentAdvancedTextComponent } from './widget-content/advanced-text/advanced-text.component';
import { WidgetService } from './widget.service';
import { WidgetRegisterService } from './widget-register.service';
import { WidgetAdministrateService } from './widget-administrate.service';
import { WidgetContentService } from './widget-content.service';
import { FiSharedWidgetModule } from '@fi-shared/widget/widget.module';
import { WidgetContentForumListingComponent } from './widget-content/forum-listing/forum-listing.component';
import { WidgetForumListingComponent } from './widget/forum-listing/forum-listing.component';
import { WidgetDocumentListingComponent } from './widget/document-listing/document-listing.component';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { WidgetContentDocumentListingComponent } from './widget-content/document-listing/document-listing';
import { WidgetContentFormListingComponent } from './widget-content/form-listing/form-listing.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        UtilitiesModule,
        FormsModule,
        MatCheckboxModule,
        NewsFeedModule,
        FiSharedWidgetModule,
        FiFormatDateModule,
        MatSelectModule,
        MatRadioModule,
        SelectSearchModule,
        MatIconModule,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatButtonModule,
    ],
    declarations: [
        WidgetComponent,
        WidgetListComponent,
        WidgetContentSitemapComponent,
        WidgetContentSitemapChildItemsComponent,
        WidgetSitemapEditComponent,
        WidgetContentForumFeedComponent,
        WidgetContentNewsFeedComponent,
        WidgetNewsFeedComponent,
        WidgetForumFeedComponent,
        WidgetSitemapComponent,
        WidgetAdvancedTextComponent,
        WidgetContentAdvancedTextComponent,
        WidgetForumListingComponent,
        WidgetContentForumListingComponent,
        WidgetDocumentListingComponent,
        WidgetContentDocumentListingComponent,
        WidgetContentFormListingComponent,
    ],
    exports: [
        WidgetComponent,
        WidgetContentSitemapComponent,
        WidgetSitemapEditComponent,
        WidgetListComponent,
        FiSharedWidgetModule,
    ],
    providers: [WidgetService, WidgetRegisterService, WidgetAdministrateService, WidgetContentService],
})
export class WidgetModule {}
